import React, { useContext } from 'react';
import { Checkbox } from '@xo-union/tk-component-switches';
import { DisplayLink } from '@xo-union/tk-ui-links';
import styles from './AffiliateCard.module.scss';
import { Editorial, Body2, Caption } from '@xo-union/tk-ui-typography';
import { AFFILIATE_RENT_THE_RUNWAY_URL, DEFAULT_AFFILIATE_IMAGE_ID } from './constants';
import { TrackingContext } from '../../../TrackingContext';

interface AffiliateCardProps {
  checked: boolean;
  onChange: () => void;
  dataTestId?: string;
  heading?: string;
  body?: string;
  linkText?: string;
  linkHref?: string;
  imageId?: string;
  disclaimerText?: string;
}

const AffiliateCard: React.FC<AffiliateCardProps> = ({
  checked,
  onChange,
  dataTestId = 'affiliate-card-checkbox',
  heading = 'Offer fashion inspo',
  body = 'Add a link to ready-to-rent looks in your dress code.',
  linkText = 'Rent the Runway',
  linkHref = AFFILIATE_RENT_THE_RUNWAY_URL,
  imageId = DEFAULT_AFFILIATE_IMAGE_ID,
  disclaimerText = 'The Knot has partnered with third parties to help you navigate and enjoy this event. Purchases made through partner links on this page may earn The Knot a commission.',
}) => {
  const imageSrc = `${process.env.REACT_APP_MEDIA_API_URL}/images/${imageId}`;
  const { track } = useContext(TrackingContext);

  const handleLinkClick = () => {
    track('Item Action Initiated', {
      action: 'rtr_added',
      actionName: 'rtr_added_link',
    });
  };

  return (
    <div className={styles.affiliateCard}>
      <div className={styles.leftContent}>
        <Checkbox checked={checked} onChange={onChange} data-testid={dataTestId} />
        <div className={styles.textSection}>
          <Editorial bold={true}>{heading}</Editorial>
          <Body2 as="div" className={styles.body2}>
            {body}
          </Body2>
          <DisplayLink
            className={styles.link}
            href={linkHref}
            color="tertiary"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={linkText}
            onClick={handleLinkClick}
          >
            {linkText}
          </DisplayLink>
        </div>
        <img src={imageSrc} alt="Woman in red cutout dress in a sunny garden." className={styles.cardImage} />
      </div>
      <Caption className={styles.captionSm}>{disclaimerText}</Caption>
    </div>
  );
};

export default AffiliateCard;
